var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "GenerateMeterConsumptions",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c("ItpAlert", { attrs: { variant: "info", show: "" } }, [
                _c(
                  "p",
                  { staticClass: "mb-0 pb-0" },
                  [
                    _c("ItpIcon", { attrs: { fa: "info-circle" } }),
                    _vm._v(" "),
                    _c("ItpText", { attrs: { wrap: "" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("pgettext")(
                              "Create consumption records from the readings available in the system between the start and end dates.",
                              "GenerateMeterConsumptions"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "ItpForm",
                {
                  ref: "mainForm",
                  attrs: { id: _vm.formId, name: _vm.formName },
                  on: {
                    submit: function($event) {
                      return _vm.evh_4186377094414664_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "min_date",
                        label: _vm._f("pgettext")(
                          "Start date",
                          "GenerateMeterConsumptions"
                        ),
                        labelAlign: _vm.labelAlign,
                        "label-cols-md": "3",
                        "content-cols-md": "4",
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormDatetime", {
                        attrs: { name: "min_date", type: "date", required: "" },
                        model: {
                          value: _vm.item.min_date,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "min_date", $$v)
                          },
                          expression: "item.min_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "max_date",
                        label: _vm._f("pgettext")(
                          "End date",
                          "GenerateMeterConsumptions"
                        ),
                        labelAlign: _vm.labelAlign,
                        "label-cols-md": "3",
                        "content-cols-md": "4",
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormDatetime", {
                        attrs: { name: "max_date", type: "date", required: "" },
                        model: {
                          value: _vm.item.max_date,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "max_date", $$v)
                          },
                          expression: "item.max_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "exact_period",
                        label: _vm._f("pgettext")(
                          "Exact period",
                          "GenerateMeterConsumptions"
                        ),
                        description: _vm._f("pgettext")(
                          "Assign the specified dates as the consumption periods, even if they differ from the reading dates.",
                          "GenerateMeterConsumptions"
                        ),
                        labelAlign: _vm.labelAlign,
                        labelColsMd: "3",
                        contentColsMd: "9"
                      }
                    },
                    [
                      _c("ItpFormCheckbox", {
                        attrs: {
                          name: "exact_period",
                          inline: "",
                          readonly: _vm.item.isReadOnly
                        },
                        model: {
                          value: _vm.item.exact_period,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "exact_period", $$v)
                          },
                          expression: "item.exact_period"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")(
                    "Generate",
                    "GenerateMeterConsumptions|Submit"
                  ),
                  form: _vm.formId,
                  type: "submit",
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("gettext")("Cancel"),
                  variant: "default",
                  disabled: _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }